import {
  getCheckInFlow,
  getCheckInItems,
  fetchTicketBurn,
  fetchValidateTicket,
  fetchPrintTicket,
  fetchExportCheckIn,
} from "../../api/checkin";
import { i18n } from "../../main";

const state = {
  checkInFlow: {},
  checkInItems: [],
  isLoadingItems: false,
  isLoadingTicketBurn: "",
  isLoadingValidateTicket: "",
  isLoadingPrintTicket: "",
  isLoadingCSV: false,
  isLoadingPDF: false,
};
const getters = {
  checkInFlow: state => state.checkInFlow,
  checkInItems: state => state.checkInItems,
  totalRemaining: state => state.checkInFlow.restantes,
  totalEntered: state => state.checkInFlow.realizados,
  percentageRemaining: state => state.checkInFlow.percentual_restantes,
  percentageEntered: state => state.checkInFlow.percentual_realizados || 0,
  isLoadingItems: state => state.isLoadingItems,
  isLoadingTicketBurn: state => state.isLoadingTicketBurn,
  isLoadingValidateTicket: state => state.isLoadingValidateTicket,
  isLoadingPrintTicket: state => state.isLoadingPrintTicket,
  isLoadingCSV: state => state.isLoadingCSV,
  isLoadingPDF: state => state.isLoadingPDF,
};
const actions = {
  async getCheckInFlow({ commit, dispatch }, productId) {
    try {
      const response = await getCheckInFlow(productId);
      commit("setCheckInFlow", response.data);
    } catch (error) {
      dispatch("showSnackbarError", error.response.data.message);
    }
  },
  async getCheckInItems({ commit, dispatch }, { productId, search }) {
    commit("setIsLoadingItems", true);
    try {
      const response = await getCheckInItems(productId, search);
      commit("setCheckInItems", response.data);
    } catch (error) {
      dispatch("showSnackbarError", error.response.data.message);
    } finally {
      commit("setIsLoadingItems", false);
    }
  },
  async undoTicketBurn({ commit, dispatch }, { itemId, search, productId }) {
    commit("setIsLoadingTicketBurn", itemId);
    try {
      await fetchTicketBurn(itemId);
      dispatch("showSnackbarSuccess", i18n.t("check-in.ticket-unburn-success"));
      dispatch("getCheckInFlow", productId);
      dispatch("getCheckInItems", { productId, search });
    } catch (error) {
      dispatch("showSnackbarError", error.response.data.message);
    } finally {
      commit("setIsLoadingTicketBurn", false);
    }
  },
  async validateTicket(
    { commit, dispatch },
    { itemId, media, search, productId }
  ) {
    commit("setIsLoadingValidateTicket", itemId);
    try {
      await fetchValidateTicket(itemId, media);
      dispatch("showSnackbarSuccess", i18n.t("check-in.ticket-burn-success"));
      dispatch("getCheckInFlow", productId);
      dispatch("getCheckInItems", { productId, search });
    } catch (error) {
      dispatch("showSnackbarError", error.response.data.message);
    } finally {
      commit("setIsLoadingValidateTicket", "");
    }
  },
  async printTicket({ commit, dispatch }, itemId) {
    commit("setIsLoadingPrintTicket", itemId);
    try {
      const response = await fetchPrintTicket(itemId);
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } catch (error) {
      dispatch("showSnackbarError", error.response.data.message);
    } finally {
      commit("setIsLoadingPrintTicket", "");
    }
  },
  async exportCheckIn(
    { commit, dispatch },
    { productId, search, exportationType }
  ) {
    if (!productId) {
      dispatch("showSnackbarError", i18n.t("check-in.select-event-to-export"));
      return;
    }

    exportationType === "CSV"
      ? commit("setIsLoadingCSV", true)
      : commit("setIsLoadingPDF", true);
    const typeExport =
      exportationType === "CSV" ? "text/csv" : "application/pdf";

    try {
      const response = await fetchExportCheckIn(
        productId,
        search,
        exportationType
      );
      const file = new Blob([response.data], { type: typeExport });
      const fileURL = URL.createObjectURL(file);

      if (exportationType === "CSV") {
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = fileURL;
        a.download = `CheckIn.csv`;
        a.click();
        window.URL.revokeObjectURL(fileURL);
      } else {
        window.open(fileURL);
      }
    } catch (error) {
      dispatch("showSnackbarError", error.response.data.message);
    } finally {
      commit("setIsLoadingCSV", false);
      commit("setIsLoadingPDF", false);
    }
  },
};
const mutations = {
  setCheckInFlow(state, flow) {
    state.checkInFlow = flow;
  },
  setCheckInItems(state, items) {
    state.checkInItems = items;
  },
  setIsLoadingItems(state, isLoading) {
    state.isLoadingItems = isLoading;
  },
  setIsLoadingTicketBurn(state, isLoading) {
    state.isLoadingTicketBurn = isLoading;
  },
  setIsLoadingValidateTicket(state, isLoading) {
    state.isLoadingValidateTicket = isLoading;
  },
  setIsLoadingPrintTicket(state, isLoading) {
    state.isLoadingPrintTicket = isLoading;
  },
  setIsLoadingCSV(state, isLoading) {
    state.isLoadingCSV = isLoading;
  },
  setIsLoadingPDF(state, isLoading) {
    state.isLoadingPDF = isLoading;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
